import React, { useState, useMemo } from "react";
import "../UIcss/Heading.css";
import Pagination from "./Pagination.jsx";
import CodeViewer from "./CodeViewer.jsx";
import { FaFont, FaCheck, FaCode } from "react-icons/fa";
import { LuCopy } from "react-icons/lu";

const fontList = [
  { name: "Abril Fatface", type: "cursive" },
  { name: "Amatic SC", type: "cursive" },
  { name: "Anton", type: "sans-serif" },
  { name: "Bangers", type: "cursive" },
  { name: "Bebas Neue", type: "sans-serif" },
  { name: "Cabin", type: "sans-serif" },
  { name: "Cinzel", type: "serif" },
  { name: "Comfortaa", type: "cursive" },
  { name: "Dancing Script", type: "cursive" },
  { name: "Dosis", type: "sans-serif" },
  { name: "Exo 2", type: "sans-serif" },
  { name: "Fjalla One", type: "sans-serif" },
  { name: "Fredoka One", type: "cursive" },
  { name: "Gloria Hallelujah", type: "cursive" },
  { name: "Indie Flower", type: "cursive" },
  { name: "Josefin Sans", type: "sans-serif" },
  { name: "Lobster", type: "cursive" },
  { name: "Merriweather", type: "serif" },
  { name: "Monoton", type: "cursive" },
  { name: "Montserrat", type: "sans-serif" },
  { name: "Nunito", type: "sans-serif" },
  { name: "Orbitron", type: "sans-serif" },
  { name: "Oswald", type: "sans-serif" },
  { name: "Pacifico", type: "cursive" },
  { name: "Permanent Marker", type: "cursive" },
  { name: "Playfair Display", type: "serif" },
  { name: "Poppins", type: "sans-serif" },
  { name: "Press Start 2P", type: "cursive" },
  { name: "Righteous", type: "cursive" },
  { name: "Roboto Slab", type: "serif" },
  { name: "Abel", type: "sans-serif" },
  { name: "Acme", type: "sans-serif" },
  { name: "Alfa Slab One", type: "cursive" },
  { name: "Alice", type: "serif" },
  { name: "Alita", type: "sans-serif" },
  { name: "Allan", type: "cursive" },
  { name: "Allerta Stencil", type: "sans-serif" },
  { name: "Amita", type: "cursive" },
  { name: "Annie Use Your Telescope", type: "cursive" },
  { name: "Architects Daughter", type: "cursive" },
  { name: "Archivo Black", type: "sans-serif" },
  { name: "Audiowide", type: "cursive" },
  { name: "Bad Script", type: "cursive" },
  { name: "Barlow Condensed", type: "sans-serif" },
  { name: "Berkshire Swash", type: "cursive" },
  { name: "Big Shoulders Display", type: "sans-serif" },
  { name: "Black Han Sans", type: "sans-serif" },
  { name: "Boogaloo", type: "cursive" },
  { name: "Bowlby One SC", type: "cursive" },
  { name: "Bree Serif", type: "serif" },
  { name: "Bubblegum Sans", type: "cursive" },
  { name: "Bungee", type: "cursive" },
  { name: "Bungee Inline", type: "cursive" },
  { name: "Bungee Shade", type: "cursive" },
  { name: "Butcherman", type: "cursive" },
  { name: "Cabin Sketch", type: "cursive" },
  { name: "Carter One", type: "cursive" },
  { name: "Caveat", type: "cursive" },
  { name: "Changa One", type: "cursive" },
  { name: "Chewy", type: "cursive" },
  { name: "Chicle", type: "cursive" },
  { name: "Coda", type: "cursive" },
  { name: "Codystar", type: "cursive" },
  { name: "Coiny", type: "cursive" },
  { name: "Concert One", type: "cursive" },
  { name: "Cookie", type: "cursive" },
  { name: "Copse", type: "serif" },
  { name: "Corben", type: "cursive" },
  { name: "Courgette", type: "cursive" },
  { name: "Covered By Your Grace", type: "cursive" },
  { name: "Crete Round", type: "serif" },
  { name: "Damion", type: "cursive" },
  { name: "Days One", type: "sans-serif" },
  { name: "Didact Gothic", type: "sans-serif" },
  { name: "DM Serif Display", type: "serif" },
  { name: "Do Hyeon", type: "sans-serif" },
  { name: "Dokdo", type: "cursive" },
  { name: "Domine", type: "serif" },
  { name: "Dongle", type: "sans-serif" },
  { name: "Dr Sugiyama", type: "cursive" },
  { name: "Duru Sans", type: "sans-serif" },
  { name: "Dynalight", type: "cursive" },
  { name: "Eater", type: "cursive" },
  { name: "El Messiri", type: "sans-serif" },
  { name: "Electrolize", type: "sans-serif" },
  { name: "Emilys Candy", type: "cursive" },
  { name: "Encode Sans Expanded", type: "sans-serif" },
  { name: "Fascinate", type: "cursive" },
  { name: "Faster One", type: "cursive" },
  { name: "Fauna One", type: "serif" },
  { name: "Finger Paint", type: "cursive" },
  { name: "Frijole", type: "cursive" },
  { name: "Fugaz One", type: "cursive" },
  { name: "Galada", type: "cursive" },
  { name: "Gentium Book Basic", type: "serif" },
  { name: "Geo", type: "sans-serif" },
  { name: "Geostar Fill", type: "cursive" },
  { name: "Germania One", type: "cursive" },
  { name: "Gidugu", type: "sans-serif" },
  { name: "Gilda Display", type: "serif" },
  { name: "Habibi", type: "serif" },
  { name: "Hachi Maru Pop", type: "cursive" },
  { name: "Hahmlet", type: "serif" },
  { name: "Halant", type: "serif" },
  { name: "Hammersmith One", type: "sans-serif" },
  { name: "Hanalei", type: "cursive" },
  { name: "Hanalei Fill", type: "cursive" },
  { name: "Handlee", type: "cursive" },
  { name: "Hanken Grotesk", type: "sans-serif" },
  { name: "Hanuman", type: "serif" },
  { name: "Happy Monkey", type: "cursive" },
  { name: "Harmattan", type: "sans-serif" },
  { name: "Headland One", type: "serif" },
  { name: "Heebo", type: "sans-serif" },
  { name: "Henny Penny", type: "cursive" },
  { name: "Hepta Slab", type: "serif" },
  { name: "Herr Von Muellerhoff", type: "cursive" },
  { name: "Hi Melody", type: "cursive" },
  { name: "Hina Mincho", type: "serif" },
  { name: "Hind", type: "sans-serif" },
  { name: "Hind Guntur", type: "sans-serif" },
  { name: "Hind Madurai", type: "sans-serif" },
  { name: "Hind Siliguri", type: "sans-serif" },
  { name: "Hind Vadodara", type: "sans-serif" },
  { name: "Holtwood One SC", type: "serif" },
  { name: "Homemade Apple", type: "cursive" },
  { name: "Homenaje", type: "sans-serif" },
  { name: "Hubballi", type: "cursive" },
  { name: "Hurricane", type: "cursive" },
  { name: "Iceberg", type: "cursive" },
  { name: "Iceland", type: "cursive" },
  { name: "Imbue", type: "serif" },
  { name: "Imperial Script", type: "cursive" },
  { name: "Imprima", type: "sans-serif" },
  { name: "Inconsolata", type: "monospace" },
  { name: "Inder", type: "sans-serif" },
  { name: "Ingrida", type: "serif" },
  { name: "Inika", type: "serif" },
  { name: "Inknut Antiqua", type: "serif" },
  { name: "Inria Sans", type: "sans-serif" },
  { name: "Inria Serif", type: "serif" },
  { name: "Inspiration", type: "cursive" },
  { name: "Inter", type: "sans-serif" },
  { name: "Inter Tight", type: "sans-serif" },
  { name: "Irish Grover", type: "cursive" },
  { name: "Island Moments", type: "cursive" },
  { name: "Istok Web", type: "sans-serif" },
  { name: "Italiana", type: "serif" },
  { name: "Italianno", type: "cursive" },
  { name: "Itim", type: "cursive" },
  { name: "Jacques Francois", type: "serif" },
  { name: "Jacques Francois Shadow", type: "cursive" },
  { name: "Jaldi", type: "sans-serif" },
  { name: "JetBrains Mono", type: "monospace" },
  { name: "Jim Nightshade", type: "cursive" },
  { name: "Joan", type: "serif" },
  { name: "Jockey One", type: "sans-serif" },
  { name: "Jolly Lodger", type: "cursive" },
  { name: "Jomhuria", type: "cursive" },
  { name: "Josefin Slab", type: "serif" },
  { name: "Jost", type: "sans-serif" },
  { name: "Joti One", type: "cursive" },
  { name: "Jua", type: "sans-serif" },
  { name: "Judson", type: "serif" },
  { name: "Julee", type: "cursive" },
  { name: "Julius Sans One", type: "sans-serif" },
  { name: "Junge", type: "serif" },
  { name: "Jura", type: "sans-serif" },
  { name: "Just Another Hand", type: "cursive" },
  { name: "Just Me Again Down Here", type: "cursive" },
  { name: "K2D", type: "sans-serif" },
  { name: "Kadwa", type: "serif" },
  { name: "Kaisei Decol", type: "serif" },
  { name: "Kaisei HarunoUmi", type: "serif" },
  { name: "Kaisei Opti", type: "serif" },
  { name: "Kaisei Tokumin", type: "serif" },
  { name: "Kalam", type: "cursive" },
  { name: "Kameron", type: "serif" },
  { name: "Kanit", type: "sans-serif" },
  { name: "Kantumruy Pro", type: "sans-serif" },
  { name: "Karantina", type: "cursive" },
  { name: "Karla", type: "sans-serif" },
  { name: "Karma", type: "serif" },
  { name: "Katibeh", type: "cursive" },
  { name: "Kaushan Script", type: "cursive" },
  { name: "Kavivanar", type: "cursive" },
  { name: "Kavoon", type: "cursive" },
  { name: "Kdam Thmor Pro", type: "sans-serif" },
  { name: "Keania One", type: "cursive" },
  { name: "Kelly Slab", type: "cursive" },
  { name: "Kenia", type: "cursive" },
  { name: "Khand", type: "sans-serif" },
  { name: "Khmer", type: "cursive" },
  { name: "Khula", type: "sans-serif" },
  { name: "Kings", type: "cursive" },
  { name: "Kirang Haerang", type: "cursive" },
  { name: "Kite One", type: "sans-serif" },
  { name: "Kiwi Maru", type: "serif" },
  { name: "Klee One", type: "cursive" },
  { name: "Knewave", type: "cursive" },
];

const HeadingRenderer = ({ font, onShowCode }) => {
  return (
    <div className="heading-card" onClick={() => onShowCode(font)}>
      <div className="heading-meta-header">
        <span className="heading-label">{font.name}</span>
        <button
          className="heading-copy-btn"
          onClick={(e) => {
            e.stopPropagation();
            onShowCode(font);
          }}
          title="View Code"
        >
          <LuCopy />
        </button>
      </div>

      <div className="heading-preview-area">
        <span
          className="heading-text-preview"
          style={{ fontFamily: `'${font.name}', ${font.type}` }}
        >
          {font.name}
        </span>
      </div>

      <div className="heading-details-footer">
        <div className="heading-desc-text">{font.type}</div>
      </div>
    </div>
  );
};

const Heading = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 40;

  const [viewerState, setViewerState] = useState({
    isOpen: false,
    name: "",
    jsx: "",
    css: "",
  });

  const totalPages = Math.ceil(fontList.length / itemsPerPage);

  const currentItems = useMemo(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return fontList.slice(indexOfFirstItem, indexOfLastItem);
  }, [currentPage]);

  const handleShowCode = (font) => {
    const importName = font.name.replace(/ /g, "+");
    const importUrl = `https://fonts.googleapis.com/css2?family=${importName}&display=swap`;
    const className = font.name.toLowerCase().replace(/ /g, "-");

    const html = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${font.name} - CodePulse UI</title>
    <!-- Include Google Font -->
    <link href="${importUrl}" rel="stylesheet">
    <style>
        /* Paste the CSS from the CSS tab here */
    </style>
</head>
<body>
    <h1 class="${className}">
        ${font.name}
    </h1>
</body>
</html>`;

    const css = `@import url('${importUrl}');\n\n.${className} {\n  font-family: '${font.name}', ${font.type};\n  font-size: 2.5rem;\n  font-weight: 700;\n  text-align: center;\n  margin-top: 50px;\n}`;

    setViewerState({
      isOpen: true,
      name: font.name,
      jsx: html,
      css: css,
    });
  };

  return (
    <div className="heading-page-wrapper">
      <div className="library-header">
        <div className="header-content">
          <h1>
            <FaFont /> Headings <span>Library</span>
          </h1>
        </div>
      </div>

      <div className="heading-grid">
        {currentItems.map((font, index) => (
          <HeadingRenderer
            key={`${font.name}-${index}`}
            font={font}
            onShowCode={handleShowCode}
          />
        ))}
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
        totalItems={fontList.length}
        itemsPerPage={itemsPerPage}
      />

      <CodeViewer
        isOpen={viewerState.isOpen}
        onClose={() => setViewerState({ ...viewerState, isOpen: false })}
        componentName={viewerState.name}
        jsxCode={viewerState.jsx}
        cssCode={viewerState.css}
      />
    </div>
  );
};

export default Heading;
